var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "toast-wrap",
    class: {
      mb: _vm.mb
    }
  }, [_c('div', {
    staticClass: "toast"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.txt))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };